import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfShowTranscriptIconProps extends SvgIconProps {}

/**
 * component used to display show origin icon in interaction space header
 * @param props - CcfShowTranscriptIconProps
 * @example - <CcfShowTranscriptIcon />
 * @returns SVG of show transcript icon in interaction space header
 */
export function CcfShowTranscriptIcon(props: CcfShowTranscriptIconProps) {
  return (
    <SvgIcon
      {...props}
      width="18"
      height="8"
      viewBox="0 0 18 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8367 1.24537C18.1072 0.884694 18.017 0.433843 17.7465 0.163333C17.3858 -0.107177 16.935 -0.0170069 16.6645 0.253503C16.6645 0.253503 13.8692 3.86031 9 3.86031C4.22099 3.86031 1.33554 0.343673 1.33554 0.253503C1.06503 -0.0170069 0.614183 -0.107177 0.253503 0.163333C-0.0170071 0.433843 -0.107177 0.884694 0.163333 1.24537C0.253503 1.33554 0.614183 1.87656 1.42571 2.50776L0.524013 3.5898C0.253503 3.95048 0.343673 4.40133 0.614183 4.67184C0.974864 4.94235 1.42571 4.85218 1.69622 4.58167L2.59792 3.49963C3.13895 3.86031 3.86031 4.22099 4.58167 4.58167L4.04065 6.02439C3.86031 6.38507 4.13082 6.83592 4.4915 7.01626C4.85218 7.1966 5.30303 6.92609 5.48337 6.56541L6.02439 5.12269C6.74575 5.30303 7.46711 5.48337 8.27864 5.48337V7.01626C8.27864 7.46711 8.63932 7.82779 9 7.82779C9.36068 7.82779 9.72136 7.46711 9.72136 7.01626V5.48337C10.5329 5.3932 11.3444 5.30303 11.9756 5.12269L12.5166 6.56541C12.697 6.92609 13.0577 7.1966 13.5085 7.01626C13.8692 6.83592 14.1397 6.38507 13.9594 6.02439L13.4183 4.58167C14.1397 4.31116 14.7709 3.95048 15.3119 3.5898L16.2136 4.76201C16.4841 5.12269 16.935 5.12269 17.2055 4.85218C17.476 4.58167 17.5662 4.13082 17.2956 3.77014L16.4841 2.6881C17.3858 1.87656 17.8367 1.33554 17.8367 1.24537V1.24537Z"
        fill="#333333"
      />
    </SvgIcon>
  );
}

export default CcfShowTranscriptIcon;
